import Error from "components/form/Error";
import TextAreaCom from "components/form/TextAreaCom";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import CityDistanceServices from "services/CityDistanceServices";
import { useEffect } from "react";
import SelectTimePicker from "./SelectTimePicker";
import InputAreaItineraryPrice from "./InputAreaItineraryPrice";

const DynamicFixedItineraryInput = ({
  dataInput,
  setDataInput,
  register,
  trigger,
  errors,
  setValue,
  // handleCityChange,
  handleChange,
  arrivalcity,
  departurecity,
  readOnly,
  selectedCityNameArrival,
  selectedCityNameDeparture,
}) => {
  useEffect(() => {
    const updatedData = [...dataInput];
    let shouldUpdate = false;

    if (dataInput.length > 0 && updatedData[0]["from_0"] !== arrivalcity) {
      updatedData[0]["from_0"] = arrivalcity;
      updatedData[0]["from_name_0"] = selectedCityNameArrival;
      shouldUpdate = true;
    }

    const lastIndex = dataInput.length - 1;
    if (
      lastIndex >= 0 &&
      updatedData[lastIndex][`to_${lastIndex}`] !== departurecity
    ) {
      updatedData[lastIndex][`to_${lastIndex}`] = departurecity;
      updatedData[lastIndex][`to_name_${lastIndex}`] =
        selectedCityNameDeparture;
      shouldUpdate = true;
    }

    for (let i = 1; i < dataInput.length; i++) {
      const previousTo = dataInput[i - 1][`to_${i - 1}`];
      const previousToName = dataInput[i - 1][`to_name_${i - 1}`];

      if (previousTo && dataInput[i][`from_${i}`] !== previousTo) {
        updatedData[i][`from_${i}`] = previousTo;
        shouldUpdate = true;
      }

      if (previousToName && dataInput[i][`from_name_${i}`] !== previousToName) {
        updatedData[i][`from_name_${i}`] = previousToName;
        shouldUpdate = true;
      }
    }

    if (shouldUpdate) {
      setDataInput(updatedData);
    }
          // eslint-disable-next-line 
  }, [dataInput, arrivalcity, departurecity, setDataInput]);

  useEffect(() => {
    const lastIndex = dataInput.length - 1;
    if (lastIndex < 0) return; // Ensure there is at least one row
  
    const fromCity = dataInput[lastIndex][`from_${lastIndex}`];
    const toCity = dataInput[lastIndex][`to_${lastIndex}`];
  
    if (fromCity && toCity && !dataInput[lastIndex][`km_${lastIndex}`]) {
      // Call API if KM is not already set
      (async () => {
        try {
          const response = await CityDistanceServices.getCityDistance({
            from_city: fromCity,
            to_city: toCity,
          });
  
          if (response.status) {
            const updatedData = [...dataInput];
            updatedData[lastIndex][`km_${lastIndex}`] = response.data.distance;
            updatedData[lastIndex][`duration_${lastIndex}`] = response.data.duration;
            setDataInput(updatedData);
  
            // Update form state
            setValue(`km_${lastIndex}`, response.data.distance);
            trigger(`km_${lastIndex}`);
          }
        } catch (error) {
          console.error("Error fetching distance:", error);
        }
      })();
    }
     // eslint-disable-next-line 
  }, [dataInput, setDataInput, setValue, trigger]);
  

  const handleCityChange = async (selectedCity, index, field) => {
    const updatedData = [...dataInput];
    updatedData[index][field] = selectedCity;
  
    const fromCity = updatedData[index][`from_${index}`];
    const toCity = updatedData[index][`to_${index}`];
  
    if (fromCity && toCity) {
      try {
        const response = await CityDistanceServices.getCityDistance({ from_city: fromCity, to_city: toCity });
        if (response.status) {
          
          updatedData[index][`km_${index}`] = response.data.distance;
          updatedData[index][`duration_${index}`] = response.data.duration;
          
          setDataInput(updatedData);
  
          // Manually update form values and trigger validation
          setValue(`km_${index}`, response.data.distance);
          trigger(`km_${index}`);
        }
      } catch (error) {
        setDataInput(updatedData);
        console.error("Error fetching distance:", error);
      }
    }
  };
  
  
  return (
    <div className="col-span-full relative">
      
      {dataInput.map((val, i) => (
        <>
          <div className="text-md mb-2">
            {val[`day_${i}`] ? val[`day_${i}`] : `Day ${i + 1}`} :
          </div>
          <div
            className="grid lg:grid-cols-8 md:grid-cols-1 gap-5 mb-3 col-span-8"
            key={i}
          >
           

            <div className="col-span-2 flex flex-col gap-y-10">
              <div className="relative">
                <SelectSingleCityOnly
                  register={register}
                  label="From"
                  name={`from_${i}`}
                  type="text"
                  readonly={readOnly}
                  selectedCity={i === 0 ? arrivalcity : val[`from_${i}`]}
                  placeholder={"--Choose--"}
                  handleCityChangeName={(selectedCit) =>
                    handleCityChange(selectedCit, i, `from_name_${i}`)
                  }
                  handleCityChange={(selectedCit) =>
                    handleCityChange(selectedCit, i, `from_${i}`)
                  }
                />
                <span className="absolute">
                  <Error errorName={errors[`from_${i}`]} />
                </span>
              </div>

              <div className="relative">
                <SelectSingleCityOnly
                  register={register}
                  label="To"
                  name={`to_${i}`}
                  type="text"
                  readonly={readOnly}
                  selectedCity={
                    i === dataInput.length - 1 ? departurecity : val[`to_${i}`]
                  }
                  placeholder={"--Choose--"}
                  handleCityChangeName={(selectedCit) =>
                    handleCityChange(selectedCit, i, `to_name_${i}`)
                  }
                  handleCityChange={(selectedCit) =>
                    handleCityChange(selectedCit, i, `to_${i}`)
                  }
                />
                <span className="absolute">
                  <Error errorName={errors[`to_${i}`]} />
                </span>
              </div>
            </div>

            <div className="col-span-2 flex flex-col gap-y-10">
              <div className="relative">
                <InputAreaItineraryPrice
                  register={register}
                  trigger={trigger}
                  label="KM"
                  type="text"
                  name={`km_${i}`}
                  readOnly={readOnly}
                  value={val[`km_${i}`]}
                  maxLength={4}
                  onChangeFunction={(e) => handleChange(e, i)}
                  placeholder={"KM"}
                  val={val}
                  fromCity={String(val[`from_${i}`] ?? '')} // pass from city
                  toCity={String(val[`to_${i}`] ?? '')} // pass to city
                />
                <span className="absolute">
                  <Error errorName={errors[`km_${i}`]} />
                </span>
              </div>

              <div className="relative">
                <SelectTimePicker
                  register={register}
                  label="Duration"
                  readOnly={readOnly}
                  name={`duration_${i}`}
                  value={val[`duration_${i}`]}
                  onChangeFunction={(value) =>
                    handleChange(
                      { target: { name: `duration_${i}`, value } },
                      i
                    )
                  }
                  fromCity={val[`from_${i}`]} // pass from city
                  toCity={val[`to_${i}`]} // pass to city
                />
                <span className="absolute">
                  <Error errorName={errors[`duration_${i}`]} />
                </span>
              </div>
            </div>

            <div className="col-span-4 relative">
              <TextAreaCom
                register={register}
                trigger={trigger}
                label="Itinerary"
                type="text"
                readOnly={readOnly}
                name={`itinerary_${i}`}
                value={val[`itinerary_${i}`]}
                placeholder={"Itinerary"}
                onChangeFunction={(e) => handleChange(e, i)}
              />
              <span className="absolute">
                <Error errorName={errors[`itinerary_${i}`]} />
              </span>
            </div>
          </div>
          <hr className="my-4" />
        </>
      ))}
    </div>
  );
};

export default DynamicFixedItineraryInput;
